/**
 * External Imports
 */
import { FC, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';

/**
 * Nexus Imports
 */
import { NeuIcon } from '@neutron/react';
import { useAnalyticsApi } from '@shared-web-analytics/react/dist';

/**
 * Internal Imports
 */
import { useUserRolesRef } from '../../../services/UserRoles';

import { logTableStart } from '../../../utils/analyticsHelpers';
import { setLastPath } from '../../../utils/helpers';

/**
 * Styling Imports
 */
import {
  IconContainer,
  InlineRelativeContainer,
  PopContent,
  PopItem,
  StyledNavTab,
  SupportDropDownContainer
} from './NavDropdown.styles';

const SupportDropdown: FC<{}> = () => {
  const [supportDropdownState, setSupportDropdownState] = useState(false);
  const [, setShowPopover] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { logTrackingEvent } = useAnalyticsApi();

  const {
    isEnterpriseAdmin,
    isMultipleRounders,
    isNonSupportRounder,
    isAllSupportRounder,
    isValidationRounder,
    isAidetValidationRounder,
    isBssrValidationRounder,
    isCSCRounder,
    isCNEdRounder,
    numOfRoles
  } = useUserRolesRef();
  return (
    <>
      {(isEnterpriseAdmin ||
        ((isNonSupportRounder ||
          isValidationRounder ||
          isAidetValidationRounder ||
          isBssrValidationRounder) &&
          isAllSupportRounder)) && (
        <>
          <StyledNavTab
            id="Supports-Tab"
            active={pathname.includes('support')}
            unit="tab"
            onBlur={() => setSupportDropdownState(false)}
            onClick={() => setSupportDropdownState(!supportDropdownState)}
          >
            <IconContainer>
              Support
              <NeuIcon color="gray" size="1x">
                arrow_drop_down
              </NeuIcon>
            </IconContainer>
          </StyledNavTab>
          <InlineRelativeContainer onBlur={() => setShowPopover(false)}>
            <SupportDropDownContainer showReportDropdown={supportDropdownState}>
              <PopItem
                className="dropdown-hover-item"
                role="option"
                tabIndex={0}
                onMouseDown={() => {
                  setLastPath('/support/csc/list');
                  navigate('/support/csc/list');
                  logTrackingEvent(logTableStart('/support/csc/list'));
                }}
              >
                <PopContent>CSC Rounding</PopContent>
              </PopItem>
              <PopItem
                className="dropdown-hover-item"
                role="option"
                tabIndex={0}
                onMouseDown={() => {
                  setLastPath('/support/cned/list');
                  navigate('/support/cned/list');
                  logTrackingEvent(logTableStart('/support/cned/list'));
                }}
              >
                <PopContent>CNEd Rounding</PopContent>
              </PopItem>
            </SupportDropDownContainer>
          </InlineRelativeContainer>
        </>
      )}
      {!isEnterpriseAdmin &&
        ((!isMultipleRounders && isCSCRounder) ||
          (numOfRoles === 2 && isAllSupportRounder) ||
          (isMultipleRounders && !isAllSupportRounder && isCSCRounder)) && (
          <Link
            key="CSC-Tab"
            id="CSC-Tab"
            to="/support/csc/list"
            onClick={() => {
              setLastPath('/support/csc/list');
            }}
          >
            <StyledNavTab
              active={pathname.includes('support') && pathname.includes('csc')}
              unit="tab"
            >
              CSC Rounding
            </StyledNavTab>
          </Link>
        )}
      {!isEnterpriseAdmin &&
        ((!isMultipleRounders && isCNEdRounder) ||
          (numOfRoles === 2 && isAllSupportRounder) ||
          (isMultipleRounders && !isAllSupportRounder && isCNEdRounder)) && (
          <Link
            key="CNED-Tab"
            id="CNED-Tab"
            to="/support/cned/list"
            onClick={() => {
              setLastPath('/support/cned/list');
            }}
          >
            <StyledNavTab
              active={pathname.includes('support') && pathname.includes('cned')}
              unit="tab"
            >
              CNEd Rounding
            </StyledNavTab>
          </Link>
        )}
    </>
  );
};

export default SupportDropdown;
